import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
const theme = createTheme({
  components: {
    MuiSlider: {
      styleOverrides: {
        root: {
          color: '#ffe426',
          '& .MuiSlider-track': {
            backgroundColor: '#ffe426',
          },
          '& .MuiSlider-thumb': {
            '&:hover, &.Mui-focusVisible': {
              boxShadow: `0px 0px 0px 8px rgba(255, 228, 38, 0.16)`,
            },
          },
        },
      },
    },
  },
});

const SliderComponent = ({
  SliderName,
  values,
  handleSliderChange,
  minValue,
  maxValue,
  handleMinInputChange,
  handleMaxInputChange,
  SliderLabel,
  SliderMaximusGlobal,
}) => {
  const { t } = useTranslation();
  return (
    <ThemeProvider theme={theme}>
      <div className="col-12 col-md-3 margin-Slider-filter">
        <div className="label-title margin-Slider-filter">{SliderName}</div>
        <div className="text-field-container">
          <TextField
            label={'Minimum ' + SliderLabel}
            type="number"
            value={minValue}
            onChange={handleMinInputChange}
            inputProps={{
              step: 1,
            }}
          />
          <TextField
            label={'Maximum ' + SliderLabel}
            type="number"
            value={maxValue}
            onChange={handleMaxInputChange}
            inputProps={{
              step: 1,
            }}
          />
        </div>
        <Slider
          value={values}
          onChange={handleSliderChange}
          min={0}
          max={SliderMaximusGlobal ? SliderMaximusGlobal : 10000}
          valueLabelDisplay="auto"
          aria-labelledby="range-slider"
        />
        <Typography id="range-slider" gutterBottom>
          {t('Intervalle')}: {values[0]} -{' '}
          {values[1] !== Infinity ? values[1] : 'Maximum'}
        </Typography>
      </div>
    </ThemeProvider>
  );
};

export default SliderComponent;
